import 'css-chunksrc/client/pages/capacityPage/toolbar/sortDropdown/styles.scss';export default {
  "sortDropdown": "_sortDropdown_1oi4p_1",
  "title": "_title_1oi4p_10",
  "root": "_root_1oi4p_16",
  "input": "_input_1oi4p_20",
  "opened": "_opened_1oi4p_36",
  "icon": "_icon_1oi4p_41",
  "listRoot": "_listRoot_1oi4p_53",
  "list": "_list_1oi4p_53",
  "option": "_option_1oi4p_69",
  "selected": "_selected_1oi4p_75"
};